export default "__VITE_ASSET__DvA7CTcG__"